module.exports = __webpack_public_path__ + "img/7d5c1e7.jpg";